import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { Subject, buffer, debounceTime, filter, map } from 'rxjs';

@Directive({
  selector: '[fpxClickDbclick]',
})
export class FpxClickDbclickDirective {
  private click$ = new Subject<MouseEvent>();

  @Output()
  doubleClick = new EventEmitter<MouseEvent>();

  @Output()
  onclick = new EventEmitter<MouseEvent>();

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this.click$.next(event);
  }

  ngOnInit() {
    this.click$
      .pipe(
        buffer(this.click$.pipe(debounceTime(250))),
        filter((list) => list.length === 2),
        map((list) => list[1])
      )
      .subscribe({
        next: (event: MouseEvent) => {
          this.doubleClick.emit(event);
        },
      });
    this.click$
      .pipe(
        buffer(this.click$.pipe(debounceTime(50))),
        filter((list) => list.length === 1),
        map((list) => list[1])
      )
      .subscribe({
        next: (event: MouseEvent) => {
          this.onclick.emit(event);
        },
      });
  }

  ngOnDestroy() {
    this.click$.complete();
  }
}
